<template>
  <div class="row">
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px; overflow-x: auto"
    >
      <template slot="header">
        <!-- <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">用户管理</h4>
            </div>
          </div>
        </div> -->

        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">套餐管理</h4>
            </div>
            <div class="ml-auto">
              <div>
                <base-button
                  style="margin-right: 30px"
                  size="sm"
                  type="danger"
                  @click="modals1 = true"
                  >查看激活码</base-button
                >
                <base-button
                  style="margin-right: 40px"
                  size="sm"
                  type="default"
                  @click="hangleCreateCdk"
                  >生成激活码</base-button
                >
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 20px">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                style="width:330px"
                  @blur="onBlur"
                  type="search"
                  class="mb-3 search-input"
                  prefix-icon="el-icon-search"
                  placeholder="搜索账号/激活IP/最后登录IP/真实IP/ua信息"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column label="id" prop="id" :min-width="60">
              </el-table-column>
              <el-table-column label="用户CDK" prop="cdk" :min-width="260">
              </el-table-column>
              <el-table-column label="套餐名称" prop="name" :min-width="160">
              </el-table-column>
              <el-table-column label="激活码次数" prop="num" :min-width="80">
                <template slot-scope="{ row }">
                  <badge type="danger">{{ row.num }} 次</badge>
                </template>
              </el-table-column>
              <el-table-column label="生成者" prop="admin_name" :min-width="90">
              </el-table-column>
              <el-table-column
                label="套餐开始时间"
                prop="start_time"
                :min-width="120"
                :formatter="timeFormatter"
              >
              </el-table-column>
              <el-table-column
                label="套餐结束时间"
                prop="end_time"
                :min-width="120"
                :formatter="timeFormatter"
              >
              </el-table-column>

              <el-table-column
                label="首次激活ip"
                prop="login_ip"
                :min-width="90"
              >
              </el-table-column>
              <el-table-column
                label="最后登录ip"
                prop="last_ip"
                :min-width="90"
              >
              </el-table-column>

              <el-table-column
                label="真实ip"
                prop="real_ip"
                :min-width="90"
              >
              </el-table-column>

              <el-table-column
                label="浏览器指纹"
                prop="ua"
                :min-width="120"
              >
              </el-table-column>

              <el-table-column
                label="最后登录时间"
                prop="last_time"
                :min-width="120"
                :formatter="timeFormatter"
              >
              </el-table-column>

              <el-table-column
                label="CDK生成时间"
                prop="add_time"
                :min-width="120"
                :formatter="timeFormatter"
              >
              </el-table-column>

              <el-table-column
                label="CDK状态"
                prop="state"
                :min-width="100"
                align="center"
              >
                <template slot-scope="{ row }">
                  <!-- <base-button
                    size="sm"
                    style="font-size: 0.685rem"
                    class="animation-on-hover"
                    type="danger"
                    @click="hangleQuery(row.id)"
                    >查看</base-button
                  > -->
                  <badge type="success" v-if="row.state == 1">正常</badge>
                  <badge type="info" v-if="row.state == 0">未使用</badge>
                  <badge type="danger" v-if="row.state == 2">停用</badge>
                  <badge type="danger" v-if="row.state == 3">限制下载</badge>
                  <badge type="primary" v-if="row.state == 4">返回货不对板</badge>
                  <badge type="warning" v-if="row.state == 5">学科网的人</badge>
                  <badge type="warning" v-if="row.state == 6">超长等待时间</badge>
                </template>
              </el-table-column>

              <el-table-column
                label="强制改状态"
                prop="state"
                :min-width="100"
                align="center"
              >
                <template slot-scope="{ row }">
                  <base-button
                    size="sm"
                    style="font-size: 0.685rem"
                    class="animation-on-hover"
                    type="default"
                    @click="hangleChengState(row.cdk,row.state)"
                    >改状态</base-button
                  >
                </template>
              </el-table-column>

              <el-table-column
                label="黑名单操作"
                prop="state"
                :min-width="100"
                align="center"
              >
                <template slot-scope="{ row }">
                  <base-button
                    size="sm"
                    style="font-size: 0.685rem"
                    class="animation-on-hover"
                    type="primary"
                    @click="hangleblack(row.cdk,row.login_ip,row.last_ip,row.real_ip,row.ua)"
                    >拉黑</base-button
                  >
                </template>
              </el-table-column>


              <el-table-column
                label="操作用户"
                prop="add_time"
                :min-width="140"
                :formatter="timeFormatter"
              >
              <template slot-scope="{ row }">
                <div class="room-type">
                    <div>
                      <base-button
                         size="sm"
                        style="
                          font-size: 0.685rem;
                        "
                        class="animation-on-hover"
                        type="danger"
                        @click="addUserNum(row.id,row.num,row.cdk)"
                        >加次数</base-button
                      >
                    </div>
                    <div>
                      <base-button
                        size="sm"
                        style="
                          font-size: 0.685rem;
                          margin-left: 0.3rem;
                        "
                        class="animation-on-hover"
                        type="default"
                        @click="addUserTime(row.id,row.cdk,changeDateFormat(row.end_time))"
                        >加时间</base-button
                      >
                    </div>
                  </div>
              </template>
              
              </el-table-column>

              <el-table-column
                label="状态修改"
                prop="state"
                :min-width="80"
                align="center"
              >
                <template slot-scope="{ row }">
                  <base-button
                    v-if="row.state === 2"
                    style="margin-left: 6px"
                    size="sm"
                    round
                    icon
                    type="danger"
                    @click="changeUserState(row.id)"
                    ><i class="tim-icons icon-button-pause"></i
                  ></base-button>
                  <base-button
                    v-if="row.state === 1"
                    style="margin-left: 6px"
                    size="sm"
                    round
                    icon
                    type="success"
                    @click="changeUserState(row.id)"
                    ><i class="tim-icons icon-triangle-right-17"></i
                  ></base-button>
                  <base-button
                    v-if="row.state === 0"
                    style="margin-left: 6px"
                    size="sm"
                    round
                    icon
                    type="success"
                    @click="changeUserState(row.id)"
                    ><i class="tim-icons icon-triangle-right-17"></i
                  ></base-button>
                  <!-- <badge v-if="row.state === 2" type="danger">限制</badge> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                显示 {{ from + 1 }} 到 {{ to }} 总数 {{ total }} 条
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </div>
      </template>
    </card>
    <div>
      <modal :show.sync="modals" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">生成激活码</h4>
        <div style="margin-top: 8px">选择套餐</div>
        <div>
          <el-select
            class="select-danger"
            placeholder="请选择套餐"
            v-model="selects.simple"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in selects.languages"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            >
            </el-option>
          </el-select>
        </div>
        <base-input
          style="margin-top: 8px"
          label="生成数量"
          type="number"
          placeholder="请输入生成数量"
          v-model="num"
        ></base-input>
        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click="doCreateCdk">确定</base-button>
          <base-button type="danger" @click.native="modals = false"
            >取消
          </base-button>
        </template>
      </modal>
    </div>


    <div>
        <modal
          modelWidth="600px"
          :show.sync="modals2"
          headerClasses="justify-content-center"
        >
          <h4 slot="header" class="title title-up">增加用户套餐时间</h4>
          <h4>当前用户：{{cdk}}</h4>
          <h4>当前到期时间：{{end_time}}</h4>
          <div>请选择需要增加的时间</div>
          <div style="padding-bottom: 10px">
            <el-select
              class="select-danger"
              placeholder="请选择需要增加的时间"
              v-model="roomOnState.simple"
              style="margin-top: 8px; width: 100%"
            >
              <el-option
                v-for="option in roomOnState.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.value"
              >
              </el-option>
            </el-select>
          </div>
          <div style="margin-top: 18px"></div>
          <template slot="footer">
            <base-button @click="handaddUserTime">确定</base-button>
            <base-button type="danger" @click.native="modals2 = false"
              >取消
            </base-button>
          </template>
        </modal>
      </div>

    <div>
      <modal :show.sync="modals1" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">激活码({{ cdknum }}个)</h4>
        <div>
          <!-- <div>生成激活码数量 {{ cdknum }} 个</div> -->
          <base-input style="padding: 0">
            <textarea
              ref="myTextarea"
              v-model="myTextareaValue"
              style="
                padding: 0;
                height: 400px !important;
                max-height: 400px !important;
              "
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
            ></textarea>
          </base-input>
        </div>

        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          "
        >
          <base-button
            type="secondary"
            @click="modals1 = false"
            style="margin-right: auto"
            >取消</base-button
          >
          <base-button
            type="primary"
            style="margin-left: auto"
            @click="modals1 = false"
            >确认</base-button
          >
        </div>
      </modal>
    </div>


    <div >
      <modal :show.sync="modals7" headerClasses="justify-content-center" id="special-modal-001">
        <h4 slot="header" class="title title-up">强制修改用户状态</h4>
        <div>当前用户：{{ usercdk }}</div>
        <div style="margin-top: 4px;">当前用户状态：
          <badge v-if="this.userState === 0" type="info">未使用</badge>
          <badge v-if="this.userState === 1" type="success">状态正常</badge>
          <badge v-if="this.userState === 2" type="danger">停用</badge>
          <badge v-if="this.userState === 3" type="danger">限制下载</badge>
                  <badge v-if="this.userState === 4" type="primary">返回货不对板</badge>
                  <badge v-if="this.userState === 5" type="warning">学科网的人</badge>
                  <badge v-if="this.userState === 6" type="warning">限制超长等待</badge>
        </div>
        <div style="margin-top: 14px;">请选择需要更改的状态:</div>

        <div>
          <el-select
            class="select-danger"
            placeholder="请选择管理员"
            v-model="selects1.simple"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in selects1.languages"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click="compulsorychangeUserState">确定</base-button>
          <base-button type="danger" @click.native="modals7 = false"
            >取消
          </base-button>
        </template>
      </modal>
    </div>


    <div >
      <modal :show.sync="modals8" headerClasses="justify-content-center" id="special-modal-001">
        <h4 slot="header" class="title title-up">拉黑用户选项</h4>
        <div>当前用户：{{ usercdk_black }}</div>
        <div style="margin-top: 4px;">激活IP：{{ login_ip_black }}
          <base-button
                    size="sm"
                    style="font-size: 0.685rem;margin-left: 8px;"
                    class="animation-on-hover"
                    type="danger"
                    @click="handBlack(usercdk_black,login_ip_black)"
                    >拉黑</base-button>
         </div>
        <div style="margin-top: 4px;">最后登录IP：{{ last_ip_black }}
          <base-button
                    size="sm"
                    style="font-size: 0.685rem;margin-left: 8px;"
                    class="animation-on-hover"
                    type="danger"
                    @click="handBlack(usercdk_black,last_ip_black)"
                    >拉黑</base-button>
        </div>
        <div style="margin-top: 4px;">真实IP：{{ real_ip_black }}
          <base-button
                    size="sm"
                    style="font-size: 0.685rem;margin-left: 8px;"
                    class="animation-on-hover"
                    type="danger"
                    @click="handBlack(usercdk_black,real_ip_black)"
                    >拉黑</base-button>
        </div>
        <div style="margin-top: 4px;">浏览器指纹：{{ ua_black }}
          <base-button
                    size="sm"
                    style="font-size: 0.685rem;margin-left: 8px;"
                    class="animation-on-hover"
                    type="danger"
                    @click="handBlack(usercdk_black,ua_black)"
                    >拉黑</base-button>
        </div>

        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click="compulsorychangeUserState">确定</base-button>
          <base-button type="danger" @click.native="modals8 = false"
            >取消
          </base-button>
        </template>
      </modal>
    </div>

    <div>
      <modal :show.sync="modals5" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">增加用户下载次数</h4>
        <h4>当前用户：{{cdk}}</h4>
          <h4>当前剩余次数：{{addoldNum}}次</h4>
        <base-input
          style="margin-top: 8px"
          label="请输入增加次数"
          type="number"
          placeholder="请输入增加次数"
          v-model="usernum"
        ></base-input>
        <div style="margin-top: 18px"></div>
        <template slot="footer">
          <base-button @click="handaddUserNum">确定</base-button>
          <base-button type="danger" @click.native="modals5 = false"
            >取消
          </base-button>
        </template>
      </modal>
    </div>
    
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";
import Swal from "sweetalert2";
import { http } from "../../util/http.js";
import { changeDateFormat, checkTime } from "../../util/utils.js";
import Badge from "@/components/Badge";
import Modal from "@/components/Modal";
import BaseTable from "@/components/BaseTable";

export default {
  components: {
    // BaseTable,
    Modal,
    Badge,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.pagination.total;
    },
  },
  data() {
    return {
      checkTime,
      changeDateFormat,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      blurredSearchQuery: "",
      propsToSearch: ["cdk", "email", "age"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      modals: false,
      modals1: false,
      modals2: false,
      modals5: false,
      num: "",
      myTextareaValue: "",
      cdknum: 0,
      packageTableData: [],
      packageColumns: [
        "id",
        "package_name",
        "site_name",
        "package_type",
        "download_num",
        "start_time",
        "end_time",
      ],
      cdkTableData: [],
      cdkColumns: [
        "id",
        "cdk",
        "package_name",
        "package_type",
        "use_time",
        "add_time",
        "state",
        "admin_username",
      ],
      selects: {
        simple: "",
        languages: [],
      },
      payTableData: [],
      payColumns: [
        "id",
        "package_name",
        "order_no",
        "trade_no",
        "pay_ip",
        "create_time",
        "pay_time",
        "pay_type",
        "pay_state",
      ],
      roomOnState: {
        simple: "",
        languages: [
          { value: 10, label: "10天" },
          { value: 30, label: "一个月" },
          { value: 90, label: "三个月" },
          { value: 180, label: "六个月" },
          { value: 365, label: "一年" },
        ],
      },
      addUserTimeId:"",
      cdk:"",
      end_time:"",
      usernum:"",
      addoldNum:"",
      userState:"",
      usercdk:"",
      modals7:false,
      modals8:false,
      selects1: {
        simple: "",
        languages: [{ value: "0", label: "未使用" },{ value: "1", label: "状态正常" },{ value: "2", label: "停用" },{ value: "3", label: "限制下载" },{ value: "4", label: "返回货不对板" },{ value: "5", label: "学科网的人" },{ value: "6", label: "超长等待时间" }]
      },
      usercdk_black:"",
      login_ip_black:"",
      last_ip_black:"",
      real_ip_black:"",
      ua_black:"",
    };
  },
  methods: {
    compulsorychangeUserState() {
      http
        .post(
          "/v1/admin/compulsoryUpdateUserState",
          {
            usercdk: this.usercdk,
            state: this.selects1.simple,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.handleCurrentChange();
          this.modals7 = false
          Swal.fire({
            icon: "success",
            title: "更改成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    hangleChengState(usercdk,state){
      this.userState = state
      this.usercdk = usercdk
      this.modals7 = true
      this.selects1.simple = state + ""
    },
    hangleblack(cdk,login_ip,last_ip,real_ip,ua){
      this.usercdk_black = cdk
      this.login_ip_black = login_ip
      this.last_ip_black = last_ip
      this.real_ip_black = real_ip
      this.ua_black = ua
      this.modals8 = true
    },
    hangleQuery(id) {
      http
        .post(
          "/v1/admin/getUserPackageInfo",
          {
            userId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
          this.packageTableData = res.data.data.packageInfo;
          this.cdkTableData = res.data.data.cdkInfo;
          this.payTableData = res.data.data.payInfo;
          this.modals1 = true;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    handBlack(cdk,data) {
      http
        .post(
          "/v1/admin/addBlackUser",
          {
            cdk: cdk,
            data: data,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "添加黑名单失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          Swal.fire({
            icon: "success",
            title: "添加黑名单成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    changeUserState(id) {
      http
        .post(
          "/v1/admin/updateUserState",
          {
            userId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.handleCurrentChange();
          Swal.fire({
            icon: "success",
            title: "更改成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    hangleCreateCdk() {
      http
        .get("/v1/admin/getAllPackage", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          let siteDataArr = [];
          res.data.data.packageData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.num = "";
          this.selects.languages = siteDataArr;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
      this.modals = true;
    },
    doCreateCdk() {
      http
        .post(
          "/v1/admin/createCdk",
          {
            packageId: this.selects.simple,
            num: this.num,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });

          let textareaValue = "";
          res.data.data.forEach((element) => {
            textareaValue += element + "\n";
          });
          this.myTextareaValue = textareaValue;
          this.cdknum = res.data.data.length;
          this.handleCurrentChange();
          this.modals = false;
          this.modals1 = true;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },

        onBlur() {
      if(this.searchQuery==""){
        this.handleCurrentChange()
      }
      // 当输入框失去焦点时，改变 blurredSearchQuery 的值
      this.blurredSearchQuery = this.searchQuery;
    },
    handleCurrentChange() {
      http
        .post(
          "/v1/admin/getAllUser",
          {
            currentPage: this.pagination.currentPage,
            perPage: this.pagination.perPage,
            searchQuery: this.searchQuery,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.pagination.total = res.data.data.total;
          this.tableData = res.data.data.tableData;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    addUserNum(id,num,cdk){
      this.addUserTimeId = id
      this.addoldNum = num
      this.cdk = cdk
      this.usernum = ""
      this.modals5 = true
    },
    handaddUserNum(){
      http
        .post(
          "/v1/admin/addUserNum",
          {
            cdkId: this.addUserTimeId,
            num: this.usernum,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          Swal.fire({
            icon: "success",
            title: "次数增加成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
          this.modals5 = false
          this.handleCurrentChange();
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    addUserTime(id,cdk,end_time){
        this.addUserTimeId = id
        this.cdk = cdk
        this.end_time = end_time
        this.modals2 = true
    },
    handaddUserTime(){
      http
        .post(
          "/v1/admin/addUserTime",
          {
            cdkId: this.addUserTimeId,
            timeNum: this.roomOnState.simple,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          Swal.fire({
            icon: "success",
            title: "套餐时间增加成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
          this.modals2 = false
          this.handleCurrentChange();
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    timeFormatter(row, column, cellValue) {
      // 在这里处理你的数据
      // row 是整个行数据
      // column 是列数据
      // cellValue 是单元格的值
      // 例如你想将名字转为大写形式：
      if (cellValue == "0001-01-01T00:00:00Z") {
        return "";
      } else {
        cellValue = changeDateFormat(cellValue);
        return cellValue;
      }
    },
  },
  mounted() {
    // 页面跳转参数接收
    // 获取 URL 中的 query 参数
    const username = this.$route.query.username;

    if (username) {
      this.searchQuery = username; // 如果有 username 参数，设置为查询条件
      this.handleCurrentChange();
    } else {
      // 如果没有 username 参数，清空 searchQuery
      this.searchQuery = "";
      // this.clearSearchQuery();
      // 立即查询用户信息
      this.handleCurrentChange();
    }
    // 清除 URL 中的查询参数
    if (this.$route.query.username) {
      this.$router.replace({ path: "/user" }); // 这里不携带任何查询参数
    }
  },
  watch: {
    blurredSearchQuery(newVal, oldVal) {
      // 监控搜索
      if (newVal == "") {
        this.handleCurrentChange();
        return;
      }
      this.handleCurrentChange();
    },
    "pagination.currentPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
    "pagination.perPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
  },
  watch: {
    blurredSearchQuery(newVal, oldVal) {
      // 监控搜索
      if (newVal == "") {
        // this.handleCurrentChange();
        return;
      }
      this.handleCurrentChange();
    },
    "pagination.currentPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
    "pagination.perPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
  },
};
</script>
<style scoped lang="scss" >
.pagination-select,
.search-input {
  width: 200px;
}
::v-deep .modal-dialog {
  max-width: 600px !important;
}
.room-type {
  display: flex;
}
</style>

<style>
#special-modal-001 .modal-dialog {
  max-width: 600px !important;
}
#special-modal-002 .modal-dialog {
  max-width: 1500px !important;
}
</style>